import React from "react";

import { FieldError, FieldValues, UseFormRegister } from "react-hook-form";

export interface SelectOption {
  value: string | undefined;
  label: string;
  disabled?: boolean;
  selected?: boolean;
}
interface Props {
  defaultValue?: string | null | undefined;
  label: string;
  name: string;
  options: SelectOption[] | null | undefined;
  error?: FieldError;
  disabled?: boolean;
}

export const WSelect = React.forwardRef<
  HTMLSelectElement,
  Props & ReturnType<UseFormRegister<FieldValues>>
>((props, ref) => {
  const { onChange, onBlur, name, defaultValue, options } = props;

  return (
    <div className="ek-input">
      <div className="relative flex items-center justify-center">
        <select
          name={name}
          defaultValue={defaultValue ?? undefined}
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          disabled={props?.disabled}
        >
          {options?.map((option, index) => (
            <option
              key={index}
              value={option.value}
              disabled={option.disabled}
              selected={option?.selected}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
});

WSelect.displayName = "Select";

export default WSelect;
